(function($){
    $('body').on('click', '.top-menu-page ul li.menu-item-has-children > a', function(e){
        e.preventDefault();
        $(this).next('ul').slideToggle(500);
        $(this).closest('li').toggleClass('active');
    })
    $('body').on('click', '.top-menu-page .show-menu', function(e){
        // e.preventDefault();
        // $(this).next('.gok-menu').slideToggle(500);
    })
})(jQuery)